import {
  Component,
  DestroyRef,
  inject,
  Input,
  OnInit,
  output,
} from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { ERRORS } from 'src/app/components/exceptions/exceptions-screen/shared/entry-errors/entry-errors.constants';
import {
  IMAGE_SRC,
  VALIDATION_MESSAGE,
} from 'src/app/components/shared/shared-constants';
import { SpecialCharacters } from 'src/app/core/enums';
import { STOP_TYPE } from 'src/app/core/enums/operations.enum';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { EDIT_STOP_CONSTANTS } from '../../edit-operations-stop/edit-operations-stop.constants';
import { LABELS } from './new-package-details.constants';

@Component({
  selector: 'app-new-package-details',
  templateUrl: './new-package-details.component.html',
  styleUrl: './new-package-details.component.scss',
  standalone: false,
})
export class NewPackageDetailsComponent implements OnInit {
  @Input() rowForm!: FormGroup;
  @Input() index!: number;
  @Input() stopType!: STOP_TYPE;
  trackingNumberList: string[] = [];
  trackingChanged = output<number>();

  addEvent = output<string[]>();
  removeEvent = output();

  readonly destroy = inject(DestroyRef);

  readonly ERRORS = VALIDATION_MESSAGE;
  readonly ERROR_LABELS = ERRORS;
  readonly LABELS = LABELS;
  readonly IMAGES = IMAGE_SRC;
  readonly NUMBER_ONLY = SpecialCharacters.NUMBER_ONLY;
  readonly REGEX = SpecialCharacters.ALPHABET_NUMBER_NO_SPACE;
  readonly STOP_TYPE = STOP_TYPE;
  readonly CONSTANTS = { ...EDIT_STOP_CONSTANTS };

  constructor(public readonly commonUtils: CommonUtils) {}

  ngOnInit(): void {
    this.commonUtils.autoCapitalize(
      this.rowForm,
      ['trackingNumber', 'shipperAccount', 'cod', 'declaredValue'],
      this.destroy,
    );
  }

  checkTrackingNumber(_event: any) {
    const trackingNumberControl = this.rowForm.get('trackingNumber');
    this.trackingNumberList.push(trackingNumberControl?.value);
    const shipperId = this.rowForm.get('shipperAccount');

    // Shipper ID logic
    if (
      trackingNumberControl?.valid &&
      (trackingNumberControl.value as string).startsWith('1Z')
    ) {
      shipperId?.setValue(trackingNumberControl.value.substring(2, 8));
    }
    this.trackingChanged.emit(this.index);
  }

  addClick() {
    this.addEvent.emit(this.trackingNumberList);
  }

  keyboardPress($event: KeyboardEvent) {
    if ($event.key === 'Enter') {
      this.checkTrackingNumber($event);
      this.addEvent.emit(this.trackingNumberList);
    }

    if ($event.key === 'Delete') {
      this.removeClick();
    }
  }

  removeClick() {
    this.removeEvent.emit();
  }

  preventMaxLimitValue(event: KeyboardEvent) {
    const allowedControlKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'Escape',
      'Enter',
      'ArrowLeft',
      'ArrowRight',
      'Home',
      'End',
    ];

    const key = event.key;

    // Allow control/navigation keys
    if (allowedControlKeys.includes(key) || event.ctrlKey || event.metaKey) {
      return true;
    }

    // Allow only digits and dot
    if (!/[0-9.]/.test(key)) {
      event.preventDefault();
      return false;
    }

    // Get current value from input
    const input = event.target as HTMLInputElement;
    const value = input.value;

    // If key is '.' and value already contains a dot → block
    if (key === '.' && value.includes('.')) {
      event.preventDefault();
      return false;
    }

    // If value already has a dot, check decimal part length
    if (value.includes('.')) {
      const [, decimalPart] = value.split('.');
      if (decimalPart && decimalPart.length >= 2 && key !== '.') {
        // Already 2 digits after dot → block further decimals
        event.preventDefault();
        return false;
      }
    }

    return true;
  }

  get hasCodValidator() {
    return this.rowForm.get('cod')?.hasValidator(Validators.required);
  }
}
